<template>
    <div id="subscribedCapitalEchart" style="width:100%;height:340px;box-shadow:0px 2px 9px 0px rgba(212,212,212,0.5);">

    </div>
</template>
<script>
export default {
    name:'subscribedCapitalEchart',
    data(){
        return{}
    },
    props: {
      title: String,
      data: Array,
    },
    methods: {

    },
    watch:{
      data:function () {
        this.$nextTick(function () {
          let data=this.data
          let monthData=[]
          for (let i = 0; i < data.length; i++) {
            monthData.push({value: data[i].shouldCapi, name: data[i].stockName})
          }
          var echarts = require('echarts');
          var myChart = echarts.init(document.getElementById('subscribedCapitalEchart'));
          var option = {
            title:{
              text:'认缴出资额（万元）',
              y:'16',
              x:'20'
            },
            color:['#3F82E4'],
            dataset: {
              source: monthData
            },
            grid: {containLabel: true},
            xAxis: {name: 'amount'},
            yAxis: {type: 'category'},
            // visualMap: {
            //     orient: 'horizontal',
            //     left: 'center',
            //     min: 10,
            //     max: 100,
            //     text: ['High Score', 'Low Score'],
            //     dimension: 0,
            //     inRange: {
            //         color: ['#D7DA8B', '#E15457']
            //     }
            // },
            series: [
              {
                type: 'bar',
                encode: {
                  // Map the "amount" column to X axis.
                  x: 'amount',
                  // Map the "product" column to Y axis
                  y: 'product'
                }
              }
            ]
          };

          myChart.setOption(option)
        })
      },
    },
    mounted () {
      let data=this.data
      let monthData=[]
      for (let i = 0; i < data.length; i++) {
        monthData.push({value: data[i].shouldCapi, name: data[i].stockName})
      }
        var echarts = require('echarts');
        var myChart = echarts.init(document.getElementById('subscribedCapitalEchart'));
        var option = {
            title:{
                text:'认缴出资额（万元）',
                y:'16',
                x:'20'
            },
            color:['#3F82E4'],
            dataset: {
                source: monthData
            },
            grid: {containLabel: true},
            xAxis: {name: 'amount'},
            yAxis: {type: 'category'},
            // visualMap: {
            //     orient: 'horizontal',
            //     left: 'center',
            //     min: 10,
            //     max: 100,
            //     text: ['High Score', 'Low Score'],
            //     dimension: 0,
            //     inRange: {
            //         color: ['#D7DA8B', '#E15457']
            //     }
            // },
            series: [
                {
                    type: 'bar',
                    encode: {
                        // Map the "amount" column to X axis.
                        x: 'amount',
                        // Map the "product" column to Y axis
                        y: 'product'
                    }
                }
            ]
        };

        myChart.setOption(option)
    }
}
</script>
<style lang="scss" scoped>

</style>
